<template>
  <section
    v-if="data"
    class="w-full overflow-hidden"
    :class="!isPlain ? [backgroundColorClass, sectionOuterSpacingClass(data)] : ''"
    :style="!isPlain ? backgroundColorStyle : {}"
  >
    <UiHeading
      v-if="data?.heading"
      :pin="data?.heading?.pin"
      :title="data?.heading?.title"
      :description="data?.heading?.description"
      :button="data?.heading?.button"
      :position="data?.heading?.position"
      :color="data?.heading?.color"
      :class="!data?.content && '!mb-0 lg:!mb-0'"
      v-aos="animate && 'zoom-out'"
    />
    <div
      v-aos="animate && 'fade-up'"
      v-if="data?.content && !isPlain"
      :class="data?.containerFull ? 'w-full px-4' : 'container px-4'"
    >
      <div 
        class="w-full bg-white border border-gray-100 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] rounded-2xl md:rounded-3xl p-6 md:p-10 lg:p-16"
      >
        <AtomsImage
          v-if="data?.mediaTop"
          class="w-full object-cover object-center rounded-2xl mb-8 md:mb-12 shadow-sm"
          :class="imageTopClass"
          :media="data?.mediaTop"
          sizeHint="content"
          :alt="imageTopAlt"
        />

        <div
          class="rich-text w-full mx-auto text-gray-700 leading-relaxed"
          :class="contentClass"
          v-html="data?.content"
        ></div>

        <AtomsImage
          v-if="data?.mediaBottom"
          class="w-full object-cover object-center aspect-[16/8] rounded-2xl mt-8 md:mt-12 shadow-sm"
          :media="data?.mediaBottom"
          sizeHint="content"
          :alt="imageBottomAlt"
        />
      </div>
    </div>

    <!-- Plain Mode for news detail etc -->
    <div v-else-if="data?.content && isPlain" class="w-full">
        <AtomsImage
          v-if="data?.mediaTop"
          class="w-full object-cover object-center rounded-2xl mb-8 md:mb-12 shadow-sm"
          :class="imageTopClass"
          :media="data?.mediaTop"
          sizeHint="content"
          :alt="imageTopAlt"
        />

        <div
          class="rich-text w-full mx-auto text-gray-700 leading-relaxed"
          :class="contentClass"
          v-html="data?.content"
        ></div>

        <AtomsImage
          v-if="data?.mediaBottom"
          class="w-full object-cover object-center aspect-[16/8] rounded-2xl mt-8 md:mt-12 shadow-sm"
          :media="data?.mediaBottom"
          sizeHint="content"
          :alt="imageBottomAlt"
        />
    </div>
  </section>
</template>
<script setup>
import { computed } from "vue";
import { sectionOuterSpacingClass } from "~/composables/sectionSpacing";
import { getAspectClass, getBrandBgClass } from "~/composables/utils";
import { useSiteSettingsStore } from "@/store/index";

const props = defineProps({
  data: {
    type: Object,
  },
  animate: { type: Boolean, default: false },
  isPlain: { type: Boolean, default: false },
});

const backgroundColorClass = computed(() => {
  const bg = props.data?.backgroundColor;
  const brandClass = getBrandBgClass(bg);
  return brandClass ? `\\` + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '') : '';
});

const backgroundColorStyle = computed(() => {
  const bg = props.data?.backgroundColor;
  if (bg && bg.startsWith("#")) {
    return { backgroundColor: bg };
  }
  return {};
});
const imageTopClass = computed(() => getAspectClass(props.data?.mediaSize));

const imageTopAlt = computed(() => props.data?.mediaTop?.alternativeText ?? props.data?.mediaTop?.hash ?? props.data?.mediaTop?.name);
const imageBottomAlt = computed(() => props.data?.mediaBottom?.alternativeText ?? props.data?.mediaBottom?.hash ?? props.data?.mediaBottom?.name);

const siteSettingsStore = useSiteSettingsStore();
const contentClass = computed(() => [
  props.data?.center && 'flex flex-col justify-center text-center',
  { 'rounded-2xl md:rounded-3xl': siteSettingsStore.roundCorner },
]);
</script>
```
